import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import axiosInstance from "../utils/axiosInstance";

function JoinChallengeModal(props) {
  const objectID = props.alldata._id;

  const requestData = {
    challenge_oid: objectID,
  };

  const joinChallenge = () => {
    axiosInstance
      .post("/challenges/participant", requestData)
      .then((response) => {
        props.onHide();
      })
      .catch((error) => {
        
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>Challenge Details</Modal.Header>
      <Modal.Body>
        <p>Are you ready to embrace this exciting challenge and take action?</p>
        <h6>Details</h6>
        <p>Title: {props.alldata.title}</p>
        <p>Organizer: {props.alldata.organizer}</p>
        <p>Start Day: {props.alldata.start_date}</p>
        <Button variant="primary" onClick={joinChallenge}>
          I am ready!
        </Button>
      </Modal.Body>
    </Modal>
  );
}

export default JoinChallengeModal;
